import React, { useState, useRef } from 'react'
import { connect } from 'react-redux'
import { httpClient } from '../../funcs'
import { notifyAboutError } from '../../methods/notifyUser'
import Popup from '../../components/Popup'
import trashIcon from '../../images/pages/tariffsV2/trash.svg'
import 'pages/Styles/UIKit_v2.sass'

type Props = {
    $store: any
    $commitToStore: (data: any) => void
    isOpen: boolean
    onClose: () => void
    billId: string
    onSuccess?: (items?: any[]) => void
    items?: any[]
}

let UploadPaymentProofPopup: any = function UploadPaymentProofPopup({ 
    $store, 
    $commitToStore, 
    isOpen, 
    onClose, 
    billId, 
    onSuccess,
    items
}: Props) {
    const [file, setFile] = useState<File | null>(null)
    const [uploading, setUploading] = useState(false)
    const fileInputRef = useRef<HTMLInputElement>(null)

    function handleFileSelect(event: React.ChangeEvent<HTMLInputElement>) {
        const selectedFile = event.target.files?.[0]
        if (selectedFile) {
            setFile(selectedFile)
        }
    }

    function handleFileClick() {
        fileInputRef.current?.click()
    }

    function handleRemoveFile() {
        setFile(null)
        if (fileInputRef.current) {
            fileInputRef.current.value = ''
        }
    }

    async function handleUpload() {
        if (!file) {
            alert('Выберите файл для загрузки')
            return
        }

        try {
            setUploading(true)
            
            // Конвертируем файл в base64
            const base64 = await fileToBase64(file)
            
            // Отправляем на сервер
            await httpClient.post('/upload-payment-proof-v2', {
                bill_id: billId,
                payment_proof: base64,
                file_type: file.type
            })

            // Уведомляем об успехе
            if (onSuccess) {
                onSuccess(items)
            }
            onClose()
            
            // Сбрасываем состояние
            setFile(null)
            if (fileInputRef.current) {
                fileInputRef.current.value = ''
            }

        } catch (error) {
            notifyAboutError({ $store, $commitToStore }, error)
        } finally {
            setUploading(false)
        }
    }

    function fileToBase64(file: File): Promise<string> {
        return new Promise((resolve, reject) => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = () => {
                const result = reader.result as string
                // Убираем префикс "data:image/jpeg;base64," или аналогичный
                const base64 = result.split(',')[1]
                resolve(base64)
            }
            reader.onerror = error => reject(error)
        })
    }

    function handleClose() {
        if (!uploading) {
            setFile(null)
            if (fileInputRef.current) {
                fileInputRef.current.value = ''
            }
            onClose()
        }
    }

    if (!isOpen) return null

    return (
        <Popup onClose={handleClose}>
            <div style={{ padding: '20px' }}>
                <div className="Body_16_v2_secondary" style={{ marginBottom: '20px' }}>
                    Выберите файл с платежным поручением (PDF, JPG, PNG)
                </div>

                {!file ? (
                    <div
                        onClick={handleFileClick}
                        style={{
                            border: '2px dashed #ccc',
                            borderRadius: '8px',
                            padding: '40px',
                            textAlign: 'center',
                            cursor: 'pointer',
                            marginBottom: '20px'
                        }}
                    >
                        <div className="Body_16_v2_secondary">
                            Нажмите для выбора файла
                        </div>
                    </div>
                ) : (
                    <div
                        style={{
                            border: '1px solid #e0e0e0',
                            borderRadius: '8px',
                            padding: '16px',
                            marginBottom: '20px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center'
                        }}
                    >
                        <div>
                            <div className="Body_16_v2">{file.name}</div>
                            <div className="Body_14_v2_secondary">
                                {(file.size / 1024 / 1024).toFixed(2)} MB
                            </div>
                        </div>
                        <button
                            onClick={handleRemoveFile}
                            disabled={uploading}
                            className="new iconed dark"
                        >
                            <img src={trashIcon} alt="Удалить файл" />
                        </button>
                    </div>
                )}

                <input
                    ref={fileInputRef}
                    type="file"
                    accept=".pdf,.jpg,.jpeg,.png"
                    onChange={handleFileSelect}
                    style={{ display: 'none' }}
                />

                <div className="buttons-container-v2" style={{ justifyContent: 'flex-end' }}>
                    <button
                        className="action-button secondary"
                        onClick={handleClose}
                        disabled={uploading}
                    >
                        <span className="button-text">Отмена</span>
                    </button>
                    
                    <button
                        className="action-button primary"
                        onClick={handleUpload}
                        disabled={!file || uploading}
                    >
                        {uploading ? (
                            <>
                                <div className="spinner" style={{ marginRight: '8px' }}></div>
                                <span className="button-text">Загрузка...</span>
                            </>
                        ) : (
                            <span className="button-text">Загрузить</span>
                        )}
                    </button>
                </div>
            </div>
        </Popup>
    )
}

UploadPaymentProofPopup = connect(
    (store) => ({ $store: store }),
    (dispatch) => ({
        $commitToStore: (data: any) => dispatch({ ...data, type: 'S' })
    })
)(UploadPaymentProofPopup)

export default UploadPaymentProofPopup
